module.exports = {
        srcSet: __webpack_public_path__ + "static/media/opportunity-check-800.9113b592.webp"+" 800w"+","+__webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp"+" 992w",
        images: [{path: __webpack_public_path__ + "static/media/opportunity-check-800.9113b592.webp",width: 800,height: 1058},{path: __webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp",width: 992,height: 1312}],
        src: __webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp",
        toString: function(){return __webpack_public_path__ + "static/media/opportunity-check-992.5db31fbf.webp"},
        
        width: 992,
        height: 1312
      }